import ky from 'ky';

import { getCookie, removeCookie, setCookie } from '@catalyze/ui';
import { Cookies } from 'constants/cookies';
import { Routes } from 'constants/routes';

import { REACT_APP_API_URL } from './constants/api-constants';
import { refreshUserToken } from './session/refreshUserToken';

export const apiClient = ky.extend({
    // eslint-disable-next-line node/no-process-env
    prefixUrl: `${REACT_APP_API_URL}/realestate/v1/`,
    // Request retry handled by react-query
    retry: 0,
    hooks: {
        beforeRequest: [
            (request) => {
                const accessToken = getCookie(Cookies.ACCESS_TOKEN);
                request.headers.set('Authorization', accessToken ?? '');
            },
        ],
        afterResponse: [
            async (request, options, response) => {
                if (response.status === 401) {
                    const refreshToken = getCookie(Cookies.REFRESH_TOKEN);
                    if (!refreshToken) {
                        logoutUser();
                        return;
                    }

                    try {
                        const refreshTokenResponse = await refreshUserToken({
                            refreshToken,
                        });

                        const { accessToken } = refreshTokenResponse;
                        if (!accessToken) {
                            logoutUser();
                            return;
                        }

                        request.headers.set('Authorization', accessToken);
                        setCookie(Cookies.ACCESS_TOKEN, accessToken);
                        return await ky(request);
                    } catch {
                        logoutUser();
                    }
                }
            },
        ],
    },
});

function logoutUser() {
    if (getCookie(Cookies.ACCESS_TOKEN)) {
        window.location.href = Routes.SIGN_IN;
    }
    removeCookie(Cookies.REFRESH_TOKEN);
    removeCookie(Cookies.ACCESS_TOKEN);
}
